import {
  MOUNT,
  UNMOUNT
} from './constants'

const mount = () => ({ type: MOUNT })
const unmount = () => ({ type: UNMOUNT })

export {
  mount,
  unmount
}
